import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { DropdownSelectField } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './BuildingDesignFeesRevenuesComponent.module.scss';
import metadata from './BuildingDesignFeesRevenuesComponent.metadata.json5';

function BuildingDesignFeesRevenuesComponent(props) {

    const {
        data: BuildingDesignFeesRevenuesVM,
        updateWizardData,
        submissionVM,
        BuildingDesignFeesRevenuesPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const totalText = "Total:"

    const addBuildingDesignFeesRevenues = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            BuildingDesignFeesRevenuesVM.value = BuildingDesignFeesRevenuesVM.value || []

            const { _xCenter, _dtoName } = BuildingDesignFeesRevenuesVM;

            const BuildingDesignBreakdownofFeesRevenuesTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            BuildingDesignFeesRevenuesVM.pushElement(
                BuildingDesignBreakdownofFeesRevenuesTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, BuildingDesignFeesRevenuesVM, viewModelService]
    );

    const getBuildingTableWithTotal = useCallback(() => {
        const rows = BuildingDesignFeesRevenuesVM.value || [];

        if (!rows.length) {
            return rows;
        }

        const totalRow = {
            desOfSerPer1: totalText, 
        };

        const columnsToTotal = ["conValPas12MonExp2", "conVal12MonPriPreYea3", "conValNex12MonAnt4", "proFeePas12MonExp5", "proFee12MonPriPreYea6", "proFeeNex12MonAnt7"];

        columnsToTotal.forEach((col) => {
            totalRow[col] = rows.reduce((sum, row) => {
                const value = Number(row[col]?.amount) || 0;
                return sum?.amount !== undefined ? { amount: sum.amount + value, currency: 'cad' } : { amount: sum + value, currency: 'cad' };
            }, 0);
        });

        return [...rows, totalRow];
    }, []);


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            BuildingDesignFeesRevenuesVM.value.splice(index, 1);
            _.set(submissionVM.value, BuildingDesignFeesRevenuesPath, BuildingDesignFeesRevenuesVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, BuildingDesignFeesRevenuesPath, BuildingDesignFeesRevenuesVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'desOfSerPer1') {
                if (item.desOfSerPer1 === totalText) return totalText;

                const value = (item && item.desOfSerPer1) ? item.desOfSerPer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = BuildingDesignFeesRevenuesVM.length > 0 && BuildingDesignFeesRevenuesVM.children[index].desOfSerPer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? BuildingDesignFeesRevenuesVM.children[index].desOfSerPer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.desOfSerPer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'conValPas12MonExp2') {
                const value = item.conValPas12MonExp2 ? item.conValPas12MonExp2 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.conValPas12MonExp2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }

            if (path === 'conVal12MonPriPreYea3') {
                const value = item.conVal12MonPriPreYea3 ? item.conVal12MonPriPreYea3 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.conVal12MonPriPreYea3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }

            if (path === 'conValNex12MonAnt4') {
                const value = item.conValNex12MonAnt4 ? item.conValNex12MonAnt4 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.conValNex12MonAnt4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }

            if (path === 'proFeePas12MonExp5') {
                const value = item.proFeePas12MonExp5 ? item.proFeePas12MonExp5 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.proFeePas12MonExp5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }

            if (path === 'proFee12MonPriPreYea6') {
                const value = item.proFee12MonPriPreYea6 ? item.proFee12MonPriPreYea6 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.proFee12MonPriPreYea6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }

            if (path === 'proFeeNex12MonAnt7') {
                const value = item.proFeeNex12MonAnt7 ? item.proFeeNex12MonAnt7 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.proFeeNex12MonAnt7 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly={item.desOfSerPer1 === totalText}
                    />
                );
            }
        }, [handleValueChange, translator, BuildingDesignFeesRevenuesVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const BuildingDesignFeesRevenuesVMData = BuildingDesignFeesRevenuesVM.value
        .flatMap(item => Object.values(item))
        .map(v => v.amount)
        .join(",");

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`BuildingDesignFeesRevenuesTable`]: {
            data: getBuildingTableWithTotal()
        }
    }), [BuildingDesignFeesRevenuesVMData, BuildingDesignFeesRevenuesVM.value?.length])

    const resolvers = {
        resolveCallbackMap: {
            addBuildingDesignFeesRevenues,
            getTableCell,
            removeAssignmentTableRow,
            getBuildingTableWithTotal
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            BuildingDesignFeesRevenuesVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [BuildingDesignFeesRevenuesVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={BuildingDesignFeesRevenuesVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BuildingDesignFeesRevenuesComponent.propTypes = wizardProps;
export default withRouter(BuildingDesignFeesRevenuesComponent);
